import AgentInboxMeta from 'models/agent_inbox/agent_inbox_meta';
import RequestAgentInbox from 'actions/inbox/agent/request_agent_inbox';

export default class IncreaseAgentInboxLimit {
  constructor(context) {
    this.context = context;
  }

  run() {
    const meta = this.context.stores.agentInboxMeta.get();
    let items = this.context.stores.agentInboxItemsNew.findAll();

    const { limit: currentLimit } = meta;

    // If we have fewer items than the limit currently, there's no need to increase it
    if (currentLimit > items.length) {
      return;
    }

    meta.setLimit(currentLimit + AgentInboxMeta.PAGE_SIZE);
    this.context.stores.agentInboxMeta.set(meta);

    // Re-request inbox
    this.context.executeAction(RequestAgentInbox);
  }
}
